// URL Parameters and Tracking Codes
export const BRAND_BASE_URL = "https://lonewolfranchpets.com";
export const CDN_BASE_URL = "https://cdn.lonewolfranchpets.com";
export const CART_BASE_URL = "https://cart.lonewolfranchpets.com";
export const LEGAL_BASE_URL = "https://legal.lonewolfranchpets.com";

// CDN Image URLs
export const CDN_IMAGES = {
  BRAND_LOGO: `${CDN_BASE_URL}/images/LWR-logo-white-square.jpg`,
  PHONE: `${CDN_BASE_URL}/images/phone.png`,
  CHECKOUT_90DAY: `${CDN_BASE_URL}/images/mbg.svg`,
  TROPHY: `${CDN_BASE_URL}/images/trophy.svg`,
  CHECKOUT_TRUCK: `${CDN_BASE_URL}/images/general_truck_icon.svg`,
};

export const PARAM = "n";
export const OBTCR = "obtcr";
export const TBATCR = "tbatcr";
export const FBTCR = "fbtcr";
export const DBTCR = "dbtcr";
export const REVTCR = "revtcr";
export const ADV = "Advertorial";
export const ADVERT = "Advertisement";
export const OPT = 'opt';
export const OBNATCR = 'obnatcr';
export const MSNTCR = 'msntcr';
export const OB = 'ob';
export const AOL = 'aol';
export const AOLTCR = 'aoltcr';
export const GDN = 'gdn';
export const GDNTCR = 'gdntcr';
export const AYAHTCR = 'ayahtcr';
export const AYAHC = 'ayahc';
export const AYAHLG = 'ayahlg';
export const ATBATCR = 'atbatcr';
export const VMXGUN = 'vmxgun';
export const RMGEM = 'rm-gem';
